<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Folder List</div>
                <button type="submit" v-on:click.prevent="addManagerToolBox" class="btn btn-primary waves-effect pull-right">Add</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="app-filter-good-table-container">
                    <!-- List Content Here -->
                    <div class="row form-group">
                        <div class="col-sm-12 col-md-4 serch-event-tab">
                            <input v-on:keyup.enter="searchCall()" type="text" class="form-control" id="searchManagerToolBox" placeholder="Search" v-model="searchManagerToolBox" name="searchManagerToolBox" />
                        </div>
                        <div class="input-group-prepend border-0">
                            <button v-on:click.prevent="searchCall()" style="height: 45px;" id="button-addon4" type="button" class="btn btn-primary"><i class="fa fa-search"></i></button> 
                            <button v-on:click.prevent="clearSearch()" style="margin-left: 10px; height: 45px;" id="button-clear" type="button" class="btn btn-danger"><i class="fa fa-times"></i></button>
                        </div> 
                        <div class="col-md-6">
                            <v-select class="input-field-si" v-model="sortManagerToolBox" 
                                name="sortManagerToolBox" 
                                placeholder="Select field for sorting"
                                label="text"
                                :options="sortManagerToolBoxArr"
                                :clearable=false>
                            </v-select>
                        </div>
                    </div>
                    <div v-if="(managerToolBoxArr)" class="internal-listing-container">
                        <template v-for="(managerToolBox, index) in managerToolBoxArr.folderData">
                            <div v-bind:key="index" class="single-listing">
                                <div class="upload-doc-img">
                                    <template>
                                        <img src="/static/images/folder-icon.png">
                                    </template>
                                </div>
                                <div class="single-listing-text" style="width:45%">
                                    <span v-b-tooltip.hover :title="managerToolBox.title">{{stringTrim(managerToolBox.title,60)}}</span>
                                </div>
                                <div class="download">
                                    <a v-on:click.prevent="downLoadfiles(managerToolBox)" class="downloadnow">Download Now!</a>
                                </div>
                                <div class="listing-user-info1">
                                    <div class="user-details">
                                        <div class="listing-user">{{managerToolBox.updated_name}}</div>
                                        <div class="listing-block-info">
                                            <div class="listing-date">{{managerToolBox.updated_date}}</div>
                                            <div class="listing-time">{{managerToolBox.updated_time}}</div>
                                        </div>
                                    </div>
                                    <!-- <b-list-group-item> -->
                                        <router-link title="documents" class="mr-2 btn btn-primary pull-right" v-show="managerToolBox.active ===  'Make Inactive'" v-bind:to="{name: 'ListManagerToolBoxByID', params:{id: managerToolBox.id}}">
                                            <i class="fa fa-list" aria-hidden="true"></i>
                                        </router-link>
                                        <router-link title="Edit It" class="mr-2 btn btn-primary pull-right" v-bind:to="{name: 'EditFolder', params:{id: managerToolBox.id}}">
                                            <i class="fa fa-pencil" aria-hidden="true"></i>
                                        </router-link>
                                        <template v-if='managerToolBox.active == "Make Inactive"'>
                                            <button type="button" title="Make It Inactive" class="btn mr-2 btn-danger pull-right" v-on:click.prevent="activeInActive(managerToolBox.id, managerToolBox.active)">
                                                <i class="fa fa-eye-slash" aria-hidden="true"></i>
                                            </button>
                                        </template>
                                        <template v-else>
                                            <button type="button" title="Make It Active" class="btn mr-2 btn-primary pull-right" v-on:click.prevent="activeInActive(managerToolBox.id, managerToolBox.active)">
                                                <i class="fa fa-eye" aria-hidden="true"></i>
                                            </button>
                                        </template>
                                    <!-- </b-list-group-item> -->
                                    <!-- <b-navbar>
                                        <b-navbar-nav>
                                            <b-nav-item-dropdown>
                                                <router-link class="btn btn-primary pull-right" v-bind:to="{name: 'EditFolder', params:{id: managerToolBox.id}}">Edit</router-link>
                                                <button class="btn btn-primary pull-right" v-on:click.prevent="activeInActive(managerToolBox.id, managerToolBox.active)">{{managerToolBox.active}}</button>
                                            </b-nav-item-dropdown>
                                        </b-navbar-nav>
                                    </b-navbar> -->
                                </div>
                            </div>
                        </template>
                    </div>
                    <div v-else class="internal-listing-container" style="text-align: center;">
                        Data Not Available
                    </div>
                    <div v-if="managerToolBoxArr.total_rows >= managerToolBoxArr.per_page">
                        <b-pagination align="center" prev-text="‹ Previous" next-text="Next ›" :total-rows="managerToolBoxArr.total_rows" v-model="currentPage" :per-page="managerToolBoxArr.per_page"></b-pagination>
                    </div>
                </div>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import BackendFooter from '@/components/backend/partials/Footer';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';
    import VueSweetalert2 from 'vue-sweetalert2';
    Vue.use(VueSweetalert2);
    var self;
    export default {
        name: 'ListFolder',
        components: {
            'v-select': vSelect,
            'app-backend-footer': BackendFooter,
        },
        mixins: [SessioMixin],
        data() {
            return {
                managerToolBoxArr: [],
                currentPage: 1,
                searchManagerToolBox: '',
                sortManagerToolBox: {text: 'Newest First', value: 'desc'},
                sortManagerToolBoxArr: [
                    {
                        text: 'Newest First',
                        value: 'desc'
                    },
                    {
                        text: 'Oldest First',
                        value: 'asc'
                    }
                ],
            }
        },
        watch: {
            currentPage: function() {
                self.loadManagetToolBox();
            },
            sortManagerToolBox: function() {
                self.loadManagetToolBox();
            },
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
            //self.checkLogin();
        },
        mounted: function () {
            self.loadManagetToolBox();
        },
        methods: {
            searchCall() {
                self.currentPage = 1;
                self.loadManagetToolBox();
            },
            clearSearch() {
                self.currentPage = 1;
                self.searchManagerToolBox = '';
                self.loadManagetToolBox();
            },
            addManagerToolBox() {
                self.$router.push('/backend/folder/add');
            },
            downLoadfiles: function (data) {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'id': data.id,
                        'page': self.currentPage,
                        'filter': self.searchManagerToolBox,
                        'sort': self.sortManagerToolBox.value,
                    }
                };
                self.showLoader();
                HTTP.get("/download/zip/file", config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                location.href = response.data.content
                            }
                            else if (response.data.code == '201') {
                                self.$swal('Info', response.data.message, 'info');
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            // activeInActive: function(id){
            //     var config = {
            //         headers: {
            //             Authorization: "Bearer " + localStorage.getItem("api_token")
            //         },
            //         data: {
            //             'deleteId': id,
            //         }
            //     };
            // },
            activeInActive: function(id, statusChange) {
               var config = {
                    headers: {Authorization: 'Bearer ' + localStorage.getItem('api_token')}
                };
                var data = {
                    id: id
                };
                    
                self.$swal({
                    title: 'Are you sure?',
                    text: '',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: statusChange,
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.post('/folder/active/inactive', data, config)
                            .then(function (response) {
                                if (response.data.code == '200') {
                                    self.loadManagetToolBox();
                                }
                            })
                            .catch(function (err) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                    self.error = err.response.data.message;
                                }
                            });
                    }
                });
            },
            loadManagetToolBox: function () {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'path': '',
                        'page': self.currentPage,
                        'filter': self.searchManagerToolBox,
                        'sort': self.sortManagerToolBox.value,
                    }
                };
                self.showLoader();
                HTTP.get("/folder/list", config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.managerToolBoxArr = response.data.content;
                                console.log(self.managerToolBoxArr);
                                if (response.data.content.length <= 0) {
                                    self.currentPage = 1;
                                }
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/backend/ManagerToolBox/ListFolder.vue